import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useFetch from './useFetch';

const useSelectableOptions = (endpoint) => {
  const fetch = useFetch();
  const { accountId, domainId } = useParams();
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    const getPage = async () => {
      try {
        setError(undefined);
        const res = await fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/${endpoint}`);

        setOptions(res.options);
      } catch (error) {
        setError(error);
      }
    };

    getPage().finally(() => setIsLoading(false));
  }, [accountId, domainId, fetch, endpoint]);

  return [options, isLoading, error];
};

export default useSelectableOptions;
